<div class="display-table-row-group">
  <span class="high-hosp-risk-display">
    {{
      showDefaultDisplay
        ? highHospRiskPercentDefaultDisplay
        : (highHospRiskPercent | percent)
    }}
  </span>
  <br />
  @if (showProgressBar) {
  <div class="progress-bar-container">
    <div class="progress-bar-background"></div>
    <div class="progress-bar" [ngStyle]="{width: widthPercent}"></div>
  </div>
  }
</div>
